import React, { useState } from "react";
import { Radio, Space, Tabs } from "antd";
import { TbCaretRight } from "react-icons/tb";

import "../../index.css";
import { color } from "framer-motion";

export const Experience = () => {
  const [tabPosition, setTabPosition] = useState("left");
  const changeTabPosition = (e) => {
    setTabPosition(e.target.value);
  };

  const workedList = [
    {
      id: 1,
      date: "May 2018 - 2019",
      companyName: "Behabesha Company",
      role: "Software Engineer",
      discription: [
        " Developed responsive web pages and user interfaces using HTML, CSS, and JavaScript. Implemented a dynamic carousel feature for the homepage, enhancing user engagement and visual appeal.",
        "Collaborated with cross-functional teams to design and develop a mobile-first e-commerce website. Integrated third-party APIs for payment processing and implemented a smooth checkout experience, resulting in a 15% increase in conversions.",
        "Created a responsive dashboard for a data analytics platform using React.js. Implemented interactive charts and graphs to visualize complex data sets, improving data analysis and decision-making for clients.",
        " Worked on a team to revamp the user interface of a content management system. Streamlined the workflow by optimizing page load times and implementing drag-and-drop functionality, resulting in a 20% increase in user productivity.",
      ],
    },
    {
      id: 2,
      date: "May 2019 - 2020",
      companyName: "HayoSpire",
      role: "Full Stack Developer",
      discription: [
        " Led the development of a scalable e-commerce platform using React.js and Node.js. Integrated payment gateways, implemented user authentication, and optimized the backend database for improved performance, resulting in a 40% increase in online sales.",
        " Developed a customer relationship management (CRM) system using Angular and NodeJS. Designed and implemented a customizable dashboard, integrated email automation, and implemented data analytics for improved customer engagement and business insights.",
        "Contributed to the development of a mobile-responsive food delivery application using React Native and NodeJS. Integrated real-time order tracking, implemented secure payment processing, and optimized the app for high performance, resulting in a 30% increase in customer retention.",
        "Led the development of a booking and reservation system using React.js and Node.js. Implemented real-time availability tracking, integrated payment gateways, and optimized the platform for search engine optimization (SEO), resulting in increased bookings and improved online visibility.",
      ],
    },
    {
      id: 3,
      date: "May 2020 - Present",
      companyName: "TilTek Company",
      role: "Full Stack Developer",
      discription: [
        "Collaborated with UX/UI designers to develop a responsive portfolio website using Angular and Express.js. Implemented smooth page transitions, optimized image loading, and integrated contact forms, resulting in increased user engagement and improved lead generation.",
        " Collaborated with UX/UI designers to develop a responsive  YouTube-like system A revolutionary video platform for discovering, watching, and sharing an endless array of captivating content from creators worldwide. With a user-friendly interface, personalized recommendations, and interactive features, this YouTube-like system offers an immersive and enjoyable viewing experience for users of all interests.",
        "Led the development of an automated appointment reminder system using SMS and IVR technologies. Integrated with scheduling platforms, implemented personalized reminders, and optimized the system for scalability, resulting in reduced appointment no-shows and improved operational efficiency for healthcare providers.",
        "As a Full Stack Developer on our job finder website, you will play a key role in creating innovative features and functionalities using a combination of front-end and back-end technologies. Your expertise will contribute to enhancing the overall user experience and driving success for job seekers and employers alike.",
      ],
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  return (
    // <div className="flex flex-col w-full bg-[#0a192f]">
    //   <h1>Where I’ve Worked</h1>
    // </div>

    <div
      name="experiance"
      className="flex flex-col w-full mt-60 md:mt-0 p-1 md:p-10 justify-center items-center "
    >
      <div className="w-2/3 hidden md:block">
        <div className="flex  items-center">
          <h1 className="text-3xl text-white pl-5 mb-5 w-96">
            Where I’ve Worked
          </h1>
          <span className="bg-gray-600 w-full h-[0.125px] mb-4"></span>
        </div>
        <Space
          style={{
            marginBottom: 24,
          }}
        ></Space>
        <Tabs
          tabPosition={tabPosition}
          style={{ color: "red" }}
          items={workedList.map((resp, i) => {
            const id = String(i + 1);
            return {
              label: (
                <span className="text-white hover:text-green-300 hover:scale-110">
                  {resp.companyName}
                </span>
              ),
              key: id,
              onTabClick: { backgroundColor: "red" },
              children: (
                <div className="flex flex-col justify-center items-start pl-10">
                  <h1 className="text-md text-white text-2xl text-left">
                    {resp.role}{" "}
               
                    <span className="text-green-300 text-left">
                      {" "}
                      @ {resp.companyName}
                    </span>
                  </h1>
                  <h1 className="text-xs text-gray-400 py-3">{resp.date}</h1>
                  {resp.discription.map((res, i) => {
                    return (
                      <div className="text-gray-400 flex items-center gap-2 pb-3">
                        <div>
                          <TbCaretRight className="text-green-300 w-5 h-5" />
                        </div>
                        <h1 className="text-md pb-1 text-left">{res}</h1>
                      </div>
                    );
                  })}
                </div>
              ),
            };
          })}
        />
      </div>

      <div className="w-full block md:hidden">
        <div className="flex  items-center">
          <h1 className="text-xl text-white pl-5 mb-5 w-96">
            Where I’ve Worked
          </h1>
          <span className="bg-gray-600 w-full h-[0.125px] mb-4 hidden "></span>
        </div>
        <Space
          style={{
            marginBottom: 24,
          }}
        ></Space>
        <Tabs
          tabPosition={"top"}
          style={{ color: "red" }}
          items={workedList.map((resp, i) => {
            const id = String(i + 1);
            return {
              label: <span className="text-white">{resp.companyName}</span>,
              key: id,
              onTabClick: { backgroundColor: "red" },
              children: (
                <div className="flex flex-col justify-center items-start pl-1">
                  <h1 className="text-md text-white text-2xl">
                    {resp.role}{" "}
                    <br/>
                    <span className="text-green-300">
                      {" "}
                      @ {resp.companyName}
                    </span>
                  </h1>
                  <h1 className="text-xs text-gray-400 py-3">{resp.date}</h1>
                  {resp.discription.map((res, i) => {
                    return (
                      <div className="text-gray-400 flex items-center gap-2 pb-3">
                        <div>
                          <TbCaretRight className="text-green-300 w-5 h-5" />
                        </div>
                        <h1 className="text-md pb-1 text-left">{res}</h1>
                      </div>
                    );
                  })}
                </div>
              ),
            };
          })}
        />
      </div>
    </div>
  );
};
